/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Form_Gps_ImeiInputs */

const vi_vehicle_form_gps_imei = /** @type {(inputs: Vehicle_Form_Gps_ImeiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IMEI thiết bị`)
};

/**

* @param {Vehicle_Form_Gps_ImeiInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_form_gps_imei = /** @type {((inputs?: Vehicle_Form_Gps_ImeiInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Form_Gps_ImeiInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_form_gps_imei(inputs)
});